import { useCallback, useRef } from 'react'

/**
 * The useThrottle hook can be used to enforce a delay between calls to the throttled function, allowing it to be called only once within the specified time period.
 * @param fn any function
 * @param delay The time calls to the function should be disregarded
 * @param deps Any deps to the underlaying useCallback
 * @returns a throttled function
 */
export const useThrottle = (fn: (...args: any[]) => void, delay: number) => {
  const timer = useRef<NodeJS.Timeout | null>(null)

  // Returning a throttled version
  return useCallback(
    (...args) => {
      if (timer.current === null) {
        // If there is no timer currently running
        fn(...args)
        timer.current = setTimeout(() => {
          // Set a timer to clear the timerFlag after the specified delay
          timer.current = null // Clear the timerFlag to allow the main function to be executed again
        }, delay)
      }
    },
    [fn]
  )
}
